import { render } from "./ConfirmationModalDelete.vue?vue&type=template&id=6b8b4590"
import script from "./ConfirmationModalDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmationModalDelete.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__